import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const ButtonContainer = styled.div `
	height: 3rem;
	display: flex;
	flex-wrap: nowrap;
	justify-content: ${p => p.Justify};

	button {
		margin: 0;
	}
`;
const CardActions = ({ children, className, style, justify }) => (React.createElement(ButtonContainer, { className: `corn-card-actions ${className || ''}`, Justify: justify, style: style || null }, children));
CardActions.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
    justify: PropTypes.oneOf([
        'flex-start',
        'flex-end',
        'center',
        'space-around',
        'space-between',
        'space-evenly'
    ])
};
CardActions.defaultProps = {
    justify: 'center'
};
export default CardActions;
